var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.047,
    height: 14.046,
    viewBox: "0 0 14.047 14.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-0.764 -0.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2116467169744",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M72.233,65.21a7.023,7.023,0,1,1-7.023,7.023A7.023,7.023,0,0,1,72.233,65.21Z",
    transform: "translate(-64.446 -64.446)",
    fill: "#4a8cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_430",
    "data-name": "Trazado 430",
    d: "M273.53,455.984v3.3a1.351,1.351,0,0,0,1.356,1.344H279.7a.246.246,0,0,0,.247-.244v-3.3a1.351,1.351,0,0,0-1.356-1.344h-4.811a.246.246,0,0,0-.247.244Zm6.72,1.287,1.986-1.451c.172-.143.306-.107.306.152V460.4c0,.294-.164.259-.306.152L280.25,459.1Z",
    transform: "translate(-270.325 -450.397)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.ca9365c02315dd0908665c2a30beabbe.svg";
export { ForwardRef as ReactComponent };